import { render, staticRenderFns } from "./AttachingImagesItem.vue?vue&type=template&id=47bbd410&scoped=true&"
import script from "./AttachingImagesItem.vue?vue&type=script&lang=ts&"
export * from "./AttachingImagesItem.vue?vue&type=script&lang=ts&"
import style0 from "./AttachingImagesItem.vue?vue&type=style&index=0&id=47bbd410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbd410",
  null
  
)

export default component.exports